import { render, staticRenderFns } from "./AppAlertsCoaSensorForm.vue?vue&type=template&id=99823fe6&"
import script from "./AppAlertsCoaSensorForm.vue?vue&type=script&lang=js&"
export * from "./AppAlertsCoaSensorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports